import View from '../../View'
import {AccessRights, ManagementAssignmentsSelection} from '../../constants'
import {UserTeamAssignmentType} from '../../panels/user/constants'

export default class ATAccessRightsChecker extends View {
    constructor() {
        super()

        this.state = {
            isBTYEnabled: false,
            isURAEnabled: false,
            isLTTEnabled: false,
            isPTOEnabled: false,
            isSDBEnabled: false,
        }
    }

    hasManageUsersRight(user) {
        return this._hasRightRegardlessFeature(user, AccessRights.MANAGE_USERS)
    }

    hasSubmitOtherUsersTTRight(user) {
        return this._hasRightRegardlessFeature(user, AccessRights.SUBMIT_OTHER_USER_TIME_TRACK)
    }

    hasEditHierarchyRight(user) {
        return this._hasRightRegardlessFeature(user, AccessRights.EDIT_HIERARCHY)
    }

    hasGenerateMoneyReportsRight(user) {
        return (this.state.isBTYEnabled || this.state.isURAEnabled) && this._hasRightRegardlessFeature(user, AccessRights.GENERATE_MONEY_REPORTS)
    }

    hasSubmitTTRight(user) {
        return this._hasRightRegardlessFeature(user, AccessRights.SUBMIT_TIME_TRACK)
    }

    hasLockTTRight(user) {
        return this.state.isLTTEnabled && this._hasRightRegardlessFeature(user, AccessRights.LOCK_TIME_TRACK)
    }

    hasManagePtoAndSickDays(user) {
        return (this.state.isPTOEnabled || this.state.isSDBEnabled) && this._hasRightRegardlessFeature(user, AccessRights.MANAGE_PTO_AND_SICK)
    }

    hasManageSystemSettingsRight(user) {
        return this._hasRightRegardlessFeature(user, AccessRights.MANAGE_GENERAL_SETTINGS)
    }

    hasManageLicenceRight(user) {
        return this._hasRightRegardlessFeature(user, AccessRights.MANAGE_GENERAL_SETTINGS)
    }

    canAccessManagersScope(user) {
        return this.hasEditHierarchyRight(user)
               || this.hasManageUsersRight(user)
               || this.hasSubmitOtherUsersTTRight(user)
               || this.hasGenerateMoneyReportsRight(user)
    }

    canAccessAllManagementScope(user) {
        return this.canAccessManagersScope(user) && (this.hasManageUsersRight(
            user) || user.managementAssignmentsSelection === ManagementAssignmentsSelection.ALL)
    }

    canAccessAllTeamScope(user) {
        return this.canAccessManagersScope(user) && (this.hasManageUsersRight(user) || user.teamAssignmentType === UserTeamAssignmentType.ALL)
    }

    hasSomeTeamAssignment(user) {
        return this.canAccessManagersScope(user)
               && (this.hasManageUsersRight(user)
                   || user.teamAssignmentType !== UserTeamAssignmentType.NO)
    }

    _hasRightRegardlessFeature(user, accessRight) {
        return user.accessRights.indexOf(accessRight) !== -1
    }
}


// WEBPACK FOOTER //
// ./web/js/util/productAccessRightsChecker/ATAccessRightsChecker.js